import { buildFacetDesignOverride, overrideReadOnly } from 'Packages/FacetRest/FacetDesignOverride';
import { FDTitleText } from '@facet-wealth/design';
import { Richtext } from 'Packages/FacetDesign/Components/Richtext';

export default buildFacetDesignOverride()
  .nameOverride('question', {
    _component: () => Richtext,
    _customProps: { Component: FDTitleText, size: 'lg' },
  }, overrideReadOnly);
